import React, { useState } from 'react';

// Components
import { Button, IconWarningCircledFull } from '@ftdr/blueprint-components-react';
import FormOfficeSearch from '@components/form/FormOfficeSearch';

import { useThemeContext } from '@ThemeContext';
import { CANT_FIND_OFFICE_AHS, CANT_FIND_OFFICE_HBW210, CANT_FIND_OFFICE_HSA } from '@constants/formField-constants';
import REText from '@components/wrappedBDS/REText';
import { IsTheme, Theme } from '@app/core/featureToggle';
import { isMobileView } from '@utils';
import { getCurrentThemeConfig } from '@app/core/theme-config';

const OfficeSearch = (props) => {
  const theme = useThemeContext();
  const [selectedOffices, setSelectedOffices] = useState([]);
  const [officeButtons, setOfficeButtons] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isMobile = isMobileView();

  function setOffices(office) {
    if (props.multiSelect) {
      if (selectedOffices && selectedOffices.length) {
        if (selectedOffices.includes(office)) {
          const filteredOffices = selectedOffices.filter((o) => {
            return o.id !== office.id;
          });
          setSelectedOffices(filteredOffices);
          return;
        }
        setSelectedOffices([...selectedOffices, office]);
      } else {
        setSelectedOffices([office]);
      }
    } else {
      setSelectedOffices([office]);
    }
  }

  function onSubmit() {
    setIsSubmitting(true);
    props.onSubmit(selectedOffices);
  }

  return (
    <div className="full-height-card add-office-drawer-card">
      <REText id="wb_findOfcLabel" variant="heading-03">
        Add an Office
      </REText>
      <>
        <div className={IsTheme(Theme.Ahs2024) ? '' : 'my-4 md:mbodyt-8'}>
          <REText
            id="Add-office_copy-label"
            variant="body-short"
            className={IsTheme(Theme.Ahs2024) ? 'my-2' : ''}
          >
            You can search for your office by City and State, ZIP Code, Phone or Distributor ID.
          </REText>
          <REText
              id="Add-office_search-by-label"
              variant="body-short"
              className={IsTheme(Theme.Ahs2024) ? 'mb-1 mt-4' : 'mt-4'}
          >
              Search by:
          </REText>
        </div>

        <FormOfficeSearch
          usaStates={props.usaStates}
          setSelectedOffices={setOffices}
          typeCode={props.typeCode}
          selectedOffices={selectedOffices}
          multiSelect={props.multiSelect}
          officeButtons={setOfficeButtons}
          excludeBrandSearch={props.excludeBrandSearch}
          userOfficeIDs={props.userOfficeIDs}
          ignoreReadOnly={props.ignoreReadOnly}
          onCancel={props.onCancel}
        />

        {officeButtons && (
          <>
            <div className="mt-6 -mx-4 md:-mx-8">
              <div className="flex flex-wrap justify-end w-full px-4 md:px-8">
                <Button
                  id="wb_addOfcBtn"
                  label="Choose Office"
                  size="small"
                  disabled={isSubmitting || !selectedOffices || selectedOffices.length === 0}
                  onClick={onSubmit}
                  shape={getCurrentThemeConfig().addOfficeButtonShape}
                  color={getCurrentThemeConfig().addOfficeChooseOfficeButtonColor}
                />
              </div>
            </div>

            <div className="flex flex-col mt-6">
              <div className="flex xs-max:justify-center mb-2">
                <IconWarningCircledFull
                  size={24}
                  color={getCurrentThemeConfig().cantFindOfficeIconColor}
                />
                <REText variant="heading-05" className="ml-2" id="office-search_not-find-office">
                  <b>Can&apos;t find your office?</b>
                </REText>
              </div>
              <div className="office-search_not-find-office">
                <REText variant="body-short" id="office-search_not-find-office-copy">
                  {theme === 'hsa' && CANT_FIND_OFFICE_HSA}
                  {theme === 'ahs' && CANT_FIND_OFFICE_AHS}
                  {theme === 'hbw210' && CANT_FIND_OFFICE_HBW210}
                </REText>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default OfficeSearch;
